// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__qbz0B","default":"Avatar_default__L1FjT","pending":"Avatar_pending__7r69+"};